import axios from 'axios';
import store from '@/store';

// const apiURL = 'https://api.classroom.xeropan.com/integration/';
const apiURL = process.env.VUE_APP_CLASSROOM_INTEGRATION_URL;
const chatApiURL = process.env.VUE_APP_ENDPOINT_URL;
const appVersion = process.env.VUE_APP_APP_VERSION;
const clientVersion = process.env.VUE_APP_APP_VERSION;

function fetchData(endpoint, requestType, requestBody, authTokenRequired) {
  const token =
    'FjMY8ykcfXHaMa9RmXLH54bGsygJntPjAg5SzCbVaWhaRXL3TJcthSfzHyjvPb8C8wqQsqbzHfmCJrHQbg7Q3Bmc29nmR75DBcJyXCwkJVsbJzGkhvLWRAV6bb8n75cS';

  const xStudentToken = store.state.users.loggedInUserProfile.user.token;

  let config = '';
  if (authTokenRequired != undefined && authTokenRequired == false) {
    config = {
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        platform: 'web',
        'App-Version': appVersion,
      },
    };
  } else {
    config = {
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'x-api-key': token,
        'x-student-token': xStudentToken,
        platform: 'web',
        'App-Version': appVersion,
      },
    };
  }

  if (
    store.state &&
    store.state.settings &&
    store.state.settings.userSelectedLanguage
  ) {
    const shortLanguageCode = store.state.settings.userSelectedLanguage;
    config.headers['Accept-Languages'] = shortLanguageCode;
  }

  config.headers['client-version'] = clientVersion;

  return new Promise((resolve, reject) => {
    if (requestType.toUpperCase() === 'POST') {
      return axios
        .post(endpoint, requestBody, config)
        .then(res => resolve(res.data))
        .catch((err) => {
          if (err && err.response) {
            return reject(err.response.data);
          }
            return reject(err);
        });
    } else if (requestType.toUpperCase() === 'GET') {
      if (requestBody) {
        return axios
          .get(endpoint, { headers: config.headers, params: requestBody })
          .then(res => resolve(res.data))
          .catch((err) => {
            if (err && err.response) {
              return reject(err.response.data);
            }
              return reject(err);
          });
      }
      return axios
        .get(endpoint, config)
        .then(res => resolve(res.data))
        .catch((err) => {
          if (err && err.response) {
            return reject(err.response.data);
          }
            return reject(err);
        });
    } else if (requestType.toUpperCase() === 'PATCH') {
      return axios
        .patch(endpoint, requestBody, config)
        .then(res => resolve(res.data))
        .catch((err) => {
          if (err && err.response) {
            return reject(err.response.data);
          }
            return reject(err);
        });
    } else if (requestType.toUpperCase() === 'DELETE') {
      if (requestBody) {
        return axios
          .delete(endpoint, { headers: config.headers, data: requestBody })
          .then(res => resolve(res.data))
          .catch((err) => {
            if (err && err.response) {
              return reject(err.response.data);
            }
              return reject(err);
          });
      }
      return axios
        .delete(endpoint, config)
        .then(res => resolve(res.data))
        .catch((err) => {
          if (err && err.response) {
            return reject(err.response.data);
          }
            return reject(err);
        });
    }
    throw new Error('Unknown HTTP method');
  });
}

export { fetchData, apiURL, chatApiURL };
